import React, { useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { TwitterTweetEmbed } from 'react-twitter-embed';

const LazyLoadTweet = ({ tweetId }) => {
  const { ref, inView } = useInView({
    triggerOnce: true, // Only trigger once the component comes into view
    rootMargin: '100px 0px', // Load a bit before it comes into view
  });

  return (
    <div ref={ref} style={{ minHeight: '500px' }}> {/* Ensure there's some space */}
      {inView ? <TwitterTweetEmbed tweetId={tweetId} /> : <div>Loading...</div>}
    </div>
  );
};

export default LazyLoadTweet;
